import React from 'react';
import { X, Check } from 'lucide-react';

interface IntendedOutcomesModalProps {
    isOpen: boolean;
    onClose: () => void;
    outcomes: string[];
}

const IntendedOutcomesModal: React.FC<IntendedOutcomesModalProps> = ({ isOpen, onClose, outcomes }) => {
    if (!isOpen) return null;

    // Use provided outcomes or generic ones if empty
    const displayOutcomes = outcomes && outcomes.length > 0 ? outcomes : [
        "A system-level viability assessment",
        "Identification of technical, regulatory & access risks",
        "A pitch-ready recommendation for industry stakeholders"
    ];

    return (
        <div className="fixed inset-0 z-[9999] flex pointer-events-none">
            {/* Background overlay with very small blur */}
            <div
                className="absolute inset-0 bg-black/5 backdrop-blur-[1px] pointer-events-auto"
                onClick={onClose}
            ></div>

            <div
                className="absolute pointer-events-auto bg-white overflow-hidden flex animate-in slide-in-from-top-4 fade-in duration-300 shadow-[0_10px_40px_rgba(0,0,0,0.15)]
                w-[90%] md:w-[746px] 
                h-auto md:h-[314.3px] 
                top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                rounded-[9.27px] border-[0.77px] border-[#E2E8F0]"
            >
                {/* Left Teal Gradient Strip - matching the exact design image */}
                <div className="w-[12px] bg-gradient-to-b from-[#347468] via-[#4A9285] to-[#7BC2B5] h-full flex-shrink-0"></div>

                <div className="flex-1 p-[32px] flex flex-col justify-between">
                    {/* Close Button - Teal circle with white X */}
                    <button
                        onClick={onClose}
                        className="absolute top-[20px] right-[24px] w-[28px] h-[28px] rounded-full bg-[#347468] flex items-center justify-center text-white hover:bg-[#2a5d54] transition-all z-10"
                    >
                        <X size={14} strokeWidth={3} />
                    </button>

                    {/* Header Section */}
                    <div className="flex items-center gap-[12px] mb-[15px]">
                        <div className="w-[18px] h-[18px] flex-shrink-0">
                            <img
                                src="/icons/Innovation-pod/Intended-outcomes-heading.png"
                                alt="Intended Outcomes"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <h2 className="text-[20px] font-bold text-[#347468] leading-none">Intended Outcomes</h2>
                    </div>

                    {/* Deliverable Items List */}
                    <div className="flex flex-col flex-1">
                        {/* Main delivery line */}
                        <div className="flex items-start gap-[12px] py-[12px] border-b-[0.77px] border-gray-100">
                            <div className="w-[12px] h-[12px] flex-shrink-0 mt-[6px] flex items-center justify-center">
                                <img
                                    src="/icons/Innovation-pod/intended-subheadings.png"
                                    alt="Check"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <p className="text-[#64748B] text-[15.5px] font-semibold leading-relaxed">
                                By completing this innovation Pod, you will deliver.
                            </p>
                        </div>

                        {/* List of outcomes */}
                        {displayOutcomes.map((outcome, index) => (
                            <div key={index} className="flex items-start gap-[12px] py-[12px] border-b-[0.77px] border-gray-100 last:border-0">
                                <div className="w-[12px] h-[12px] flex-shrink-0 mt-[6px] flex items-center justify-center">
                                    <img
                                        src="/icons/Innovation-pod/intended-subheadings.png"
                                        alt="Check"
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                                <span className="text-[#64748B] text-[15.5px] font-semibold leading-relaxed">
                                    {outcome}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntendedOutcomesModal;
